import React, { useState } from "react";
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SubscriptionInfo from "./components/SubscriptionInfo";
import PaymentMethods from "./components/PaymentMethods";
import Invoices from "./components/Invoices";

function SubscriptionSettings() {
  const [tabValue, setTabValue] = useState(0);

  return (
    <div className="d-flex flex-column">
        <div className="card">
          <div className="card-header">
            <Tabs value={tabValue} onChange={(e, newVal) => setTabValue(newVal)}>
              <Tab
                value={0}
                label="Subscription"
              />
              <Tab value={1} label="Payment Methods" />
              <Tab value={2} label="Invoices"/>
            </Tabs>
          </div>
          <div className="card-body">
              {tabValue === 0 && (
                <SubscriptionInfo />
              )}
              {tabValue === 1 && (
                <PaymentMethods />
              )}
              {tabValue === 2 && (
                <Invoices />
              )}
          </div>
        </div>
    </div>
  );
}

export default SubscriptionSettings;
